import { GMTInfo, Page } from './common';
import { SKU, Specification } from './sku';
import { APIError } from '../api/types';
import { useRequestImmer } from '../api/hooks';

export const InventoryEndpoint = `/inventory`;

export enum InventoryTypeEnum {
  Purchase = 1,
  StockTaking = 2,
}

export enum InventoryListStatus {
  // 创建 待对账
  Created = 0,

  // 已对账 待结算
  Reconciled = 2,

  // 已结算
  Settled = 4,

  // 已结清
  Cleared = 8,
}

export interface InventoryList {
  id;
  supplierId: number;
  status: InventoryListStatus;
  name: string;
  sn: string;
  type: InventoryTypeEnum;
  creator: string;
  addTime: string;
  memo: string;

  price: number;
  cost: number;

  // 进货
  amount: number;
  prepayAmount: number;
  paidAmount: number;

  // 盘点
  countNegative: number;
  countPositive: number;
  countExpected: number;
  countActual: number;
}

export interface InventoryItemServer extends Partial<GMTInfo> {
  id?: number;
  goodsSn?: string;
  goodsName?: string;
  goodsPicUrl?: string;
  supplierId?: number;

  purchaseNum?: number;
  price?: number;
  cost?: number;

  // 实际数量
  countExpected?: number;
  countActual?: number;

  spId?: SKU['spId'];
  goodsId?: SKU['id'];
  specificationId?: Specification['id'];
}

export interface InventoryItem {
  supplierId?: number;
  loading?: boolean;
  loaded?: boolean;
  error?: {
    code?: APIError['code'];
    msg?: APIError['msg'];
  };

  purchaseNum?: number;
  price?: number;
  cost?: number;

  // 实际数量
  countExpected?: number;
  countActual?: number;

  goods: SKU;
  specification: Specification;
  updateSpecification: Specification;
}

export const useGetInventoryList = () =>
  useRequestImmer<{ list: InventoryList[]; page: Page }>(
    {
      url: `${InventoryEndpoint}`,
    },
    {
      manual: true,
    }
  );

export const usePostDataToInventory = (action: string) =>
  useRequestImmer<InventoryList>(
    {
      url: `${InventoryEndpoint}/${action}`,
      method: 'post',
    },
    { manual: true }
  );

export type InventoryDetailPageProps = {
  summary: InventoryList;
  items: InventoryItem[];
} & {
  pageBack: () => void;
};

export type InventoryDetailResponse = {
  summary: InventoryList;
  items: InventoryItem[];
};

export const useGetInventoryDetail = (listSn: string) =>
  useRequestImmer<InventoryDetailResponse>(
    {
      url: `${InventoryEndpoint}/list/${listSn}`,
    },
    {
      manual: true,
    }
  );

export const usePostSupplierLog = () =>
  useRequestImmer<InventoryList>(
    {
      url: `${InventoryEndpoint}/{type}`,
      method: 'post',
    },
    {
      manual: true,
    }
  );
